import formatValueCsv, { ExportColumn } from './exportUtils'

export interface ProcessRowsParams {
  dataSource: Record<string, unknown>[]
  mainColumns: ExportColumn[]
  detailColumns: ExportColumn[]
  detailDataIndex: string
  activeColumns: ExportColumn[]
  exportDetails: boolean
}

type CellValue = string | number

const processRows = ({
  dataSource,
  mainColumns,
  detailColumns,
  detailDataIndex,
  activeColumns,
  exportDetails,
}: ProcessRowsParams): CellValue[][] => {
  const rows: CellValue[][] = []

  if (exportDetails) {
    dataSource.forEach((record) => {
      const mainRow = activeColumns.map((col, index) => {
        if (index < mainColumns.length) return formatValueCsv(record[col.dataIndex], col, record)
        return ''
      })
      rows.push(mainRow)

      const detailData = record[detailDataIndex]
      const details = Array.isArray(detailData) ? (detailData as Record<string, unknown>[]) : []
      details.forEach((detail) => {
        const detailRow = activeColumns.map((col, index) => {
          if (index < mainColumns.length) return ''
          const detailCol = detailColumns[index - mainColumns.length]
          return formatValueCsv(detail[detailCol.dataIndex], detailCol, detail)
        })
        rows.push(detailRow)
      })
    })
  } else {
    dataSource.forEach((record) => {
      const row = mainColumns.map((col) => formatValueCsv(record[col.dataIndex], col, record))
      rows.push(row)
    })
  }

  return rows
}

export default processRows
